import error from '@client/assets/icons/error.svg';
import { Provider } from '@arc-connect/schema';
import { Button } from '@arcadiapower/design-system';
import { useTranslation } from 'react-i18next';
import { ty } from '@client/styles/typography';
import { ContentSection, ContentSectionFullHeight, Footer } from '../connect-container';
import { Status, CenteredColumn } from './mfa-unsupported-screen.style';

export type Props = {
  provider: Provider;
  onProviderReselect?: () => void;
};

export const MFAUnsupportedScreen = ({ provider, onProviderReselect }: Props): JSX.Element => {
  const { t } = useTranslation('connect', { keyPrefix: 'components.mfaUnsupportedScreen' });
  return (
    <ContentSectionFullHeight>
      <ContentSection centerContentVertically centerContentHorizontally>
        <CenteredColumn>
          <Status src={error} />
          <p className={ty('default')}>
            {t('description.firstLine', {
              providerName: provider.name,
            })}
          </p>
          <p className={ty('default')} style={{ margin: '10px 0 0 0' }}>
            {t('description.secondLine')}
            <span>{onProviderReselect ? t('description.reselectProvider') : ''}</span>
          </p>
        </CenteredColumn>
      </ContentSection>
      {onProviderReselect ? (
        <Footer>
          <Button
            type="button"
            className="w-full"
            variant="inverse"
            aria-label={t('selectButton')}
            onClick={onProviderReselect}
          >
            {t('selectButton')}
          </Button>
        </Footer>
      ) : null}
    </ContentSectionFullHeight>
  );
};
